import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Explore All Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Click any category to browse curated product finds in our Sugargoo Spreadsheet database.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-lg bg-background-100 hover:bg-primary-50 transition-colors border border-background-200/70 hover:border-primary-200 cursor-pointer overflow-hidden"
            >
              <div className="w-full aspect-square overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Sugargoo Spreadsheet ${cat.name} category`}
                  title={`Sugargoo Spreadsheet - ${cat.name}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 md:p-4 text-center">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}